import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { PR_STATUS, PR_STATUS_LABEL } from "../status"

const STEPS = [
  PR_STATUS.NEW,
  PR_STATUS.PENDING,
  PR_STATUS.INFO_REQUESTED,
  PR_STATUS.APPROVED,
]

const StatusStepper = ({ status }) => {
  const currentIdx = STEPS.indexOf(status)
  const isRejected = status === PR_STATUS.REJECTED

  return (
    <MDBox display="flex" gap={1} alignItems="center" flexWrap="wrap">
      {STEPS.map((step, idx) => {
        const reached = currentIdx >= idx
        const active = currentIdx === idx
        return (
          <MDBox key={step} display="flex" alignItems="center" gap={1}>
            <MDBox
              width="2rem"
              height="2rem"
              borderRadius="50%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgColor={reached ? "info" : "light"}
              color={reached ? "white" : "text"}
            >
              <MDTypography
                variant="caption"
                fontWeight="bold"
                color={reached ? "white" : "text"}
              >
                {idx + 1}
              </MDTypography>
            </MDBox>
            <MDTypography
              variant="caption"
              fontWeight={active ? "bold" : "regular"}
              color={reached ? "dark" : "text"}
            >
              {PR_STATUS_LABEL[step]}
            </MDTypography>
            {idx < STEPS.length - 1 && (
              <MDBox width="2rem" height="2px" bgColor="light" mx={0.5} />
            )}
          </MDBox>
        )
      })}
      {isRejected && (
        <MDBox ml={2}>
          <MDTypography variant="caption" color="error" fontWeight="bold">
            {PR_STATUS_LABEL[PR_STATUS.REJECTED]}
          </MDTypography>
        </MDBox>
      )}
    </MDBox>
  )
}

export default StatusStepper
